import { StatsInfoPanel } from './StatsInfoPanel';
export class StatsInfo {
    show = false;
    mode = 0;
    actualFps = 0;
    dom;
    beginTime;
    prevTime;
    frames = 0;
    container;
    msPanel;
    fpsPanel;
    constructor(show = false) {
        this.show = show;
        this.beginTime = Date.now();
        this.prevTime = this.beginTime;
        if (!this.show)
            return;
        this.container = document.createElement('div');
        const style = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
        this.container.setAttribute('style', style);
        this.container.id = 'stats-info';
        this.container.addEventListener('click', (event) => {
            event.preventDefault();
            this.mode += 1;
            this.showPanel(this.mode % this.container.children.length);
        }, false);
        this.dom = this.container;
        this.fpsPanel = new StatsInfoPanel('FPS', '#0ff', '#002');
        this.addPanel(this.fpsPanel);
        this.msPanel = new StatsInfoPanel('MS', '#0f0', '#020');
        this.addPanel(this.msPanel);
        this.showPanel(0);
        document.body.appendChild(this.dom);
    }
    addPanel(panel) {
        this.container.appendChild(panel.dom);
    }
    showPanel(id) {
        for (let i = 0; i < this.container.children.length; i += 1) {
            this.container.children[i].setAttribute('style', `display = ${i === id ? 'block' : 'none'}`);
        }
        this.mode = id;
    }
    begin() {
        this.beginTime = Date.now();
        this.prevTime = this.beginTime;
        this.frames = 0;
    }
    restartAfterPausedGame() {
        this.prevTime = Date.now();
        this.frames = 0;
    }
    setFps(time = Date.now()) {
        if (this.frames === 0)
            return;
        this.actualFps = Math.round((this.frames * 1000) / (time - this.prevTime));
        this.prevTime = time;
        this.frames = 0;
    }
    end() {
        this.frames += 1;
        const time = Date.now();
        if (this.show)
            this.msPanel.update(time - this.beginTime, 200);
        if (time >= this.prevTime + 500) {
            if (this.show)
                this.fpsPanel.update((this.frames * 1000) / (time - this.prevTime), 100);
            this.setFps(time);
        }
        return time;
    }
    update() {
        this.beginTime = this.end();
    }
}
//# sourceMappingURL=StatsInfo.js.map